module.exports = __webpack_public_path__ + "fonts/whitney_700.woff";